import { render, staticRenderFns } from "./RecomendedBox.vue?vue&type=template&id=a84f47e4&scoped=true&"
import script from "./RecomendedBox.vue?vue&type=script&lang=js&"
export * from "./RecomendedBox.vue?vue&type=script&lang=js&"
import style0 from "./RecomendedBox.vue?vue&type=style&index=0&id=a84f47e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84f47e4",
  null
  
)

export default component.exports